import React from 'react';
import { MenuItem as KitenMenuItem } from '@ui-kitten/components';
function MenuItem(props) {
    function onPress(e) {
        props.onPress && props.onPress(e);
        props.onSelect && props.onSelect(props.value);
    }
    return <KitenMenuItem {...props} onPress={onPress}/>;
}
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map